<header class="bg-flap-black sticky top-0 z-50 border-b-[3px] border-signal-orange">
  <div class="px-4 md:px-6 py-4">
    <div class="flex items-center justify-between">
      <!-- Left: Brand -->
      <a routerLink="/" class="flex items-center gap-2 hover:opacity-80 transition-opacity">
        <!-- Brand mark, not a page heading - each page supplies its own h1 -->
        <div class="text-flap-yellow text-xl md:text-2xl font-bold tracking-wide">
          FLIPPYBOARDS.COM
        </div>
      </a>

      <!-- Right: User info (when logged in) -->
      @if (isAuthenticated()) {
        @if (user(); as userData) {
          <div class="flex items-center gap-3 md:gap-4">
            <!-- User info: links to profile page -->
            <a
              routerLink="/profile"
              title="My profile"
              class="flex items-center gap-3 md:gap-4 hover:opacity-80 transition-opacity"
            >
              <!-- User name (hidden on mobile) -->
              <div class="text-right hidden md:block">
                <p class="font-semibold text-flap-yellow text-sm">
                  {{ userData.name || userData.email }}
                </p>
                <p class="text-bg-secondary text-xs">{{ userData.email }}</p>
              </div>

              <!-- User avatar: better-auth image, else Gravatar, else initials -->
              @if (userData.image || gravatarUrl(); as avatar) {
                <img
                  [src]="avatar"
                  [alt]="userData.name || 'User avatar'"
                  class="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-signal-orange"
                />
              } @else {
                <div
                  class="w-8 h-8 md:w-10 md:h-10 rounded-full bg-signal-orange text-white flex items-center justify-center font-bold text-sm border-2 border-signal-orange"
                >
                  {{ (userData.name || userData.email || 'U')[0].toUpperCase() }}
                </div>
              }
            </a>

            <!-- Logout button -->
            <button
              (click)="logout()"
              class="px-3 py-1.5 md:px-4 md:py-2 bg-transparent border-2 border-rail-gray text-rail-gray rounded-lg font-semibold text-xs md:text-sm hover:bg-rail-gray hover:text-white transition-all cursor-pointer"
              type="button"
              title="Log out"
            >
              Log out
            </button>
          </div>
        }
      }
    </div>
  </div>
</header>
